import React from 'react';

interface TourGuideButtonsProps {
    id?: string;
    onGeneralTour: () => void;
    onDetailTour: () => void;
    detailLabel: string;
}

export const TourGuideButtons: React.FC<TourGuideButtonsProps> = ({
    id,
    onGeneralTour,
    onDetailTour,
    detailLabel,
}) => (
    <div id={id} className="d-flex flex-wrap gap-2">
        <button type="button" className="btn btn-sm btn-outline-info fw-bold" onClick={onGeneralTour}>
            <i className="fas fa-map-signs me-1" /> Guía del módulo
        </button>
        <button type="button" className="btn btn-sm btn-outline-secondary fw-bold" onClick={onDetailTour}>
            <i className="fas fa-question-circle me-1" /> {detailLabel}
        </button>
    </div>
);
